import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "../../assets/styles/comentarios.module.css";
import api from "../Services/api";
import GA4React from "ga-4-react";

const Comentario = (props: any) => {

  const [comment, setComments] = useState<any[]>([]);
  const [commentLengt, setCommentLengt] = useState(0);
  const [errorEmail, setErrorEmail] = useState("");
  const [errorCheckBox, setErrorCheckBox] = useState("");
  const [error, setError] = useState("");
  const link = useParams();
  // get url query params
  var noticiaId = window.location.toString().split('Id=')[1];
  // const [isloaded, setIsloaded] = useState(false);
  // const [ga, setGa] = useState<GA4React>();
  // const { REACT_APP_GOOGLE_GA_TAG } = process.env; 
  // const sendEvent = (categoria: string, label: string) => {
  //     ga?.event(categoria, label, categoria)
  // }

  // useEffect(() => {
  //   if (!isloaded) {
  //     setIsloaded(true);
  //     try {
  //       const ga4react = new GA4React(
  //         REACT_APP_GOOGLE_GA_TAG ?? 'G-R0BM8HM4F8',
  //         { /* ga custom config, optional */ },
  //         [ /* additional code, optional */],
  //         3000 /* timeout, optional, defaults is 5000 */,
  //         /* { nonce: ['first-script-is-async','second-script'] } */
  //       );
  //       ga4react.initialize().then((ga4) => {
  //         console.log("App", decodeURIComponent(document.title));
  //       }, (err) => {
  //         console.error(err)
  //       })
	// 			setGa(ga4react);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }
  // }, [isloaded]);

  useEffect(() => {
    // setError("Não foi possível enviar seu comentário! Favor tentar novamente.");
    api.get("/ObterComentariosFiltro?id=" + noticiaId).then((response) => {
      setComments(response.data);
      setCommentLengt(response.data.length);
    })
      .catch((err) => {
        throw new Error(err);
      });
  }, [noticiaId]);

  // Handle input 
  const [form, setForm] = useState({
    nome: "",
    email: "",
    comentario: "",
    aceite: 0,
  });

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  };

  function clearForm() {
    try {
      //@ts-ignore
      document.getElementById('email').value = ''; document.getElementById('comment').value = ''; document.getElementById('name').value = ''; document.getElementById('aceite').checked = false;
      setForm({
        nome: "",
        email: "",
        comentario: "",
        aceite: 0,
      });
      // setError("Comentário enviado está sujeito a aprovação!");      
    } catch (e: any) {
      throw new Error(e);
    }
  }

  function handleSubmit(event: any) {
    event.preventDefault();
    if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(form.email)) return (setErrorEmail("* Digite um email válido"));
    setErrorEmail("");
    if (!form.aceite) return (setErrorCheckBox("* Campo obrigatório"));
    setErrorCheckBox("");
    if (form.nome === "" || form.email === "" || form.comentario === "" || !form.aceite) return (setError("* Preencha todos os campos"));
    setError("");
    api.post("/InserirComentario", {
      nome: form.nome,
      email: form.email,
      mensagem: form.comentario,
      noticiaID: noticiaId,
      aceite: form.aceite ? 1 : 0
    }).then((response) => {

      props.sendEvent("Comentarios", "Comentou_uma_noticia")

      clearForm();
      setError("Comentário enviado está sujeito a aprovação!");
      setTimeout(() => { setError(""); }, 3000);
    })
      .catch((err) => {
        setError("Não foi possível enviar seu comentário! Favor tentar novamente.");
        throw new Error(err);
      });

  }

  function formatDateAno(dateUtc: any) {
    if (dateUtc) {
      return new Date(dateUtc).getDate() + ' de ' + new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' }).toString() + ' de '
        + new Date(dateUtc).getFullYear().toString();
    }
  }

  function getComments() {

    comment.sort((a, b) => {
      // Primeiro critério: ComentarioRespostaID e ID (relacionamento pai-filho)
      const comentarioRespostaIDA = a.ComentarioRespostaID || a.ID;
      const comentarioRespostaIDB = b.ComentarioRespostaID || b.ID;

      if (comentarioRespostaIDA < comentarioRespostaIDB) {
        return -1;
      } else if (comentarioRespostaIDA > comentarioRespostaIDB) {
        return 1;
      }

      // Segundo critério: Dtcriacao
      const dataA = new Date(a.Dtcriacao).getTime();
      const dataB = new Date(b.Dtcriacao).getTime();

      return dataA - dataB;
    });
    //const x = { id: 123 };
    if (comment && comment instanceof Array) {
      return comment;
    }
    else {
      return [];
    }
    //return comment;
  }


  return (
    <>
      <div className="_form comentaios">
        <form action="">
          <div className="row justify-content-end">
            <div className="col-12 mb-5"> <h3> Deixe seu comentário </h3></div>
            <div className="col-md-6 mb-6">
              <label htmlFor=""> Nome completo </label>
              <input id="name" onChange={e => handleChange(e)} type="text" name="nome" required />
            </div>

            <div className="col-md-6 mb-6">
              <label htmlFor=""> E-mail </label>
              <span style={{
                fontWeight: 'bold',
                marginBlockStart: '10px',
                position: 'relative',
                left: '15px',
                color: 'rgb(232, 116, 0)',
              }}>{errorEmail}</span>
              <input id="email" onChange={e => handleChange(e)} type="email" name="email" required />

            </div>

            <div className="col-12 mb-6">
              <label htmlFor=""> Mensagem </label>
              <textarea id="comment" onChange={e => handleChange(e)} name="comentario" required maxLength={832}></textarea>
            </div>
            <div className="col-12 mb-6" style={{ display: 'flex' }}>
              <input type="checkbox" id="aceite" onChange={e => handleChange({ target: { name: e.target.name, value: e.target.checked } })} name="aceite" required
                style={{
                  position: 'relative',
                  top: '4px',
                  height: '20px',
                  width: '20px',
                  backgroundColor: '#E87400',
                  borderRadius: '50%',
                  marginRight: '10px',
                  marginLeft: '4px'
                }}></input>
              <label style={{
                fontWeight: 'bold',
                position: 'relative',
                left: '10px',
                width: '90%',
                color: 'rgb(232, 116, 0)',
              }} htmlFor=""> Ao clicar em enviar, seu nome poderá ser publicado no comentário e seu e-mail poderá ser utilizado pela Forluz para contato, caso necessário.</label>
              <span style={{
                fontWeight: 'bold',
                marginBlockStart: '10px',
                position: 'relative',
                left: '15px',
                color: 'rgb(232, 116, 0)',
              }}>{errorCheckBox}</span>
            </div>
            {/* <span style={{
              fontWeight: 'bold',
              marginBlockStart: '15px',
              position: 'relative',
              left: '10px',
              color: 'rgb(232, 116, 0)',
            }}>Ao clicar em enviar, seu nome poderá ser publicado no comentário e seu e-mail poderá ser utilizado pela Forluz para contato, caso necessário.</span> */}
            <span style={{
              fontWeight: 'bold',
              marginBlockStart: '15px',
              position: 'relative',
              left: '10px',
              color: 'rgb(232, 116, 0)',
            }}>{error}</span>

            <div className="col-md-4 col-lg-3">
              {<button type="button" onClick={e => handleSubmit(e)} className="btn  rounded d-block"> Enviar </button>}
            </div>
          </div>
        </form>
      </div>
      <div className="comentarios-list mt-10 pt-10">
        <h3> <span className="text-primary"> {commentLengt} </span> Comentários </h3>
        <ul className="list-unstyled pl-0 mt-6">
          {getComments()?.map((item: any) => (
            <li className={item.ComentarioRespostaID && item?.ComentarioRespostaID?.toString() !== "0" ? 'info-resposta' : ''}>

              <>
                {item.ComentarioRespostaID && item?.ComentarioRespostaID?.toString() !== "0"
                  ? <>
                    <div className="infos" >
                      <p>
                        <strong style={{ color: "#e87400" }}> {item.Nome} </strong> <br />
                        <small> {formatDateAno(item.Dtcriacao)} </small>
                      </p>
                    </div>
                    <div className="coment-resposta text-medium">
                      <p style={{ wordWrap: "break-word", maxWidth: "650px" }}>
                        {item.Mensagem}
                      </p>
                    </div></>
                  : <>
                    <div className="infos" >
                      <p>
                        <strong> {item.Nome} </strong> <br />
                        <small> {formatDateAno(item.Dtcriacao)} </small>
                      </p>
                    </div>
                    <div className="coment text-medium">
                      <p style={{ wordWrap: "break-word", maxWidth: "650px" }}>
                        {item.Mensagem}
                      </p>
                    </div></>
                }</>

            </li>
          ))}
        </ul>
      </div>
    </>
  )





};
export default Comentario;